export const CREATE_SALES_PERSON = ` 
    mutation CreateSalesPerson($name:String!, $department:String!) {
        createSalesPerson(name:$name, department:$department){
            salesPerson {
                id
                name
                code
            }       
            errors {
                property
                description
            }       
        }
    }
`;

export const UPDATE_SALES_PERSON = ` 
    mutation UpdateSalesPerson($id: ID!, $name:String) {
        updateSalesPerson(id: $id, name:$name){
            salesPerson {
                id
                name
                code
            }       
            errors {
                property
                description
            }       
        }
    }
`;     

export const DELETE_SALES_PERSON = ` 
    mutation DeleteSalesPerson($id: ID!) {
        deleteSalesPerson(id: $id){
            success
            errors {
                property
                description
            }      
        }
    }
`;

export const GET_SALES_PERSON = `
query SalesPerson($id:ID!) {    
    salesPerson(id: $id) {
        name
        code 
        department
    }   
    }
`;

export const GET_SALES_PERSON_DEPARTMENTS = `
  query SalesDepartments{
    salesPersonDepartments
}`
